import React, { useEffect } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ButtonBox from '../../components/ButtonBox';
import { useNavigate } from 'react-router-dom';
import { ROUTE_THING_INFOMAIN, THING_ID } from '../../constants';
import IconButtonBox from '../../components/IconButtonBox';
import '../../style/Thing.css';
import ThingBucket from '../../components/ThingBucket';
import useThingStore from '../../stores/ThingStore';
import ThingApi from '../../api/ThingApi';
import { ThingBucketType, ThingShape } from '../../types/ThingType';
import { getLocalStorage, useError } from '../../utils/functions';

const ThingEditBuckets: React.FC = () => {
  const { setError } = useError();
  const navigate = useNavigate();

  const { labelBuckets, setLabelBuckets } = useThingStore();

  const goTo = () => {
    navigate(ROUTE_THING_INFOMAIN);
  }

  const handleUpdate = async () => {
    if (getLocalStorage(THING_ID)) {
      let isError = false;
      for (let bucket of labelBuckets) {
        if (bucket.id === bucket.viewId) {
          if (bucket.dataShapes && bucket.dataShapes.length > 0) {
            const resOrg = await ThingApi.listDataShapes(getLocalStorage(THING_ID), bucket.id);
            if (resOrg && resOrg.length > 0) {
              for (let shape of bucket.dataShapes) {
                if (shape.viewShapeId === shape.id) {
                  let hasModify = false;
                  for (let org of resOrg) {
                    if (org.id === shape.id &&
                      (org.alias !== shape.alias ||
                        org.unit !== shape.unit)) {
                      hasModify = true;
                    }
                  }

                  if (hasModify) {
                    const res = await ThingApi.updateDataShape(getLocalStorage(THING_ID), bucket.id, shape.id, shape.alias, shape.unit);
                    if (res.code) {
                      setError(res.message);
                      isError = true;
                      break;
                    }
                  }
                } else {
                  const res = await ThingApi.createDataShape(getLocalStorage(THING_ID), bucket.id, shape);
                  if (res.code) {
                    setError(res.message);
                    isError = true;
                    break;
                  }
                }
              }

              const extraItems = resOrg.filter(
                (item: any) => !bucket.dataShapes.some((shape) => shape.id === item.id)
              );

              for (let item of extraItems) {
                const res = await ThingApi.deleteShape(getLocalStorage(THING_ID), bucket.id, item.id);
                if (res.code) {
                  setError(res.message);
                  isError = true;
                }
              }

            }
          }

        } else {
          const res = await ThingApi.createDataBucket(getLocalStorage(THING_ID), bucket);
          if (res.code) {
            setError(res.message);
            isError = true;
          }
        }

        if (isError) {
          break;
        }
      }

      if (!isError) {
        goTo();
      }
    }
  }

  const getBucket = async () => {
    if (getLocalStorage(THING_ID) !== '') {
      const res = await ThingApi.listDataBuckets(getLocalStorage(THING_ID));

      if (res && res.length > 0) {
        const newBuckets: ThingBucketType[] = [];
        for (let data of res) {

          const newDataShapes: any[] = [];
          if (data.dataShapes && data.dataShapes.length > 0) {
            for (let shape of data.dataShapes) {
              const newShape: ThingShape = {
                id: shape.id,
                viewShapeId: shape.id,
                alias: shape.alias,
                unit: shape.unit,
                valueType: shape.valueType
              };

              newDataShapes.push(newShape);
            }
          }

          const newBucket: ThingBucketType = {
            id: data.id,
            viewId: data.id,
            dataShapes: newDataShapes
          };

          newBuckets.push(newBucket);
        }
        setLabelBuckets(newBuckets);
      } else if (res.code) {
        setError(res.message);
      }
    }

  };

  useEffect(() => {
    getBucket();
  }, []);

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <IconButtonBox
          icon={<KeyboardBackspaceIcon />}
          text='Back to thing list'
          onClick={goTo} />
      </Box>
      <Typography className='thing_typography_title'>Edit buckets</Typography>
      <Box sx={{ padding: 2 }}>
        <ThingBucket />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <ButtonBox
            variant="outlined"
            text="Cancel"
            onClick={goTo} />

          <ButtonBox
            variant="contained"
            text="Save"
            onClick={handleUpdate} />
        </Box>
      </Box>
    </Box >
  );
};

export default ThingEditBuckets;
